import {
    getCaptchaSecurityCode
} from '../global/_getCaptchaSecurityCode'

const showPin = () => {
    $("#gift-cards").addClass('active');
    $(".hidden-form-gc-pin").show();
    $('#newPinError, #pinLengthError').remove();
}

const hidePin = () => {
    $("#gift-cards").removeClass('active');
    $(".hidden-form-gc-pin").hide();
    $('#newPinError, #pinLengthError').remove();
}

const showHidePin = (gcValue) => {
	if (gcValue){
        if ((gcValue.match(/^[5-6]/g))||(gcValue.match(/^984000158.*/g))){
            showPin();
        } else{
            hidePin();
        };
    }
};

const checkShowPin = (gcValue) => {
    if (gcValue.match(/^[5-6]/g)) {
        showPin();
        $(".captchaContainer").hide();
        resetModal();
    } else if (gcValue.match(/^984000158.*/g)) {
        showPin();
        $(".captchaContainer").hide();
        resetModal();
    } else if (gcValue.match(/^[4]/g)) {
        popModal();
    } else {
        hidePin();
        $(".captchaContainer").hide();
        resetModal();
    }
};

var popModalAvailable = true;

const popModal = () => {
	if(popModalAvailable){
		popModalAvailable = false;
		$('#old-style-card-modal').modal('show');
		$('#old-style-card-modal').addClass('in');
	}
}

const resetModal = () => {
	popModalAvailable = true;
}

export {
    checkShowPin,
    showHidePin
}
